module.exports = __webpack_public_path__ + "img/icon_60px_19_blue.03657c9b.svg";